import React from 'react'
import { createTheme } from "@mui/material";

export const theme = createTheme({})